import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { InputX, Button } from 'components'
import shSymbol from 'images/tmp_shinhan_symbol.png'

const DataSearchResult = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: "기관 검색",
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding flex_1">
				<div className="form-group search-bar">
					<InputX type="text" defaultValue="신한" placeholder="검색어를 입력해주세요." id="" />
					<i className="icon icon_search" />
				</div>
				<ul className="check-area mt_40">
					<li>
						<div className="check-title">은행 <span>2</span></div>
						<div className="check-list">
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={shSymbol} alt="" />
									</div>
									<div className="ml_10">
										<p>신한은행</p>
									</div>
								</div>
								<div className="chk">
									<input type="checkbox" id="check1" name="check" />
									<label htmlFor="check1">
										<span></span>
									</label>
								</div>
							</div>
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={shSymbol} alt="" />
									</div>
									<div className="ml_10">
										<p>신한은행</p>
									</div>
								</div>
								<div className="chk">
									<input type="checkbox" id="check2" name="check" />
									<label htmlFor="check2">
										<span></span>
									</label>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className="check-title">카드 <span>2</span></div>
						<div className="check-list">
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={shSymbol} alt="" />
									</div>
									<div className="ml_10">
										<p>신한은행</p>
									</div>
								</div>
								<div className="chk">
									<input type="checkbox" id="check3" name="check" />
									<label htmlFor="check3">
										<span></span>
									</label>
								</div>
							</div>
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={shSymbol} alt="" />
									</div>
									<div className="ml_10">
										<p>신한은행</p>
									</div>
								</div>
								<div className="chk">
									<input type="checkbox" id="check4" name="check" />
									<label htmlFor="check4">
										<span></span>
									</label>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">적용 <strong>2</strong></Button>
			</div>
		</div>
	)
}

export default DataSearchResult
